<template>
<div>
      <div class="layout-breadcrumb">
        <Breadcrumb>
            <BreadcrumbItem to="/">
                <Icon type="social-buffer-outline" style="color:#fff"></Icon> 
                <span style="color:#fff">系统管理</span>
            </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="layout-content" >

         

      </div>
</div>
     
</template>
<style scoped>
  ul,li{
    list-style: none;
  }
  .table-wrapper {
    overflow: scroll;
  }
  .flowChart{
    /*border:solid 1px red;*/
    width:670px;
    height:400px;
    color:#fff;
    display: inline-block;
  }
  .flowChartRight{
    width:150px;
    height:400px;
    color:#fff;
    display: inline-block;
    margin-left:100px;
    position: absolute;
  }
  .layout-menu-left {
    background: rgba(33,33,33,0.8);
    position: absolute;
    width: 200px;
    /*height: 100%;*/
    /*border-right: 1px solid lightgray;*/
    left: 0;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
    color:#fff;
    border: none;
  }
  .layout-breadcrumb {
    padding: 8px 15px;
    background: #6E7B8B;
    /*border:solid 1px #000;*/
  }
  .ivu-breadcrumb a{
    border:solid 1px blue;
    color:#fff !important;
  }
  .layout-content-right {
    margin-left: 200px;
    position: relative;
    min-height: calc(100vh - 90px);
    min-height: -webkit-calc(100vh - 90px);
    min-width: -moz-calc(100vh - 90px);
  }
  .layout-content{
    background: none;
    /*border:solid 1px red;*/
  }
  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }

  .rightTitle{
    display:inline-block;margin-bottom:10px;margin-left: -50px;
  }
  /*流程图*/
  .startBorder{
    width:0;
    height:80px;
    border-left: 2px solid #22b4fa;
    position: absolute;
    margin-top: 33px;
    margin-left: -2px;
  } 
  .borderBottom{
    margin-top: -30px;
    height: 65px;
  }
  .flowPart,.flowPart a{
    display: inline-block;
  }
  .flowList{
    width:60px;
    height:60px;
    text-align:center;
    border-radius:5px;
    border: 1px solid #22b4fa;
    box-shadow: 0 0 5px #22b4fa inset;
    position:relative;
    display: inline-block;
  }
  .flowList img{
    width:60px;
    height:10px;
    border:solid 1px red;
    position: absolute;
    left: 0;
    top:0;
    border-radius:5px 5px 0 0;
  }
  .flowList i{
    font-size: 30px;
    line-height: 65px;
  }
  .flowInfo{
    width: 60px;
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
  }
  .arrowBox{
    display: inline-block;
    border-top: solid 2px #22b4fa;
    width:46px;
    position: relative;
    margin-left: -2px;
    top: -10px;
  }
  .arrowTop{
     display: inline-block;
     border-left: solid 2px #22b4fa;
      height:28px;
      position: absolute;
      margin-left: -35px;
      top: -29px;
  }
  .arrowBottom{
     display: inline-block;
     border-left: solid 2px #22b4fa;
     height:12px;
     position: absolute;
     margin-left: -35px;
     top: -16px;
  }
  #triangle-facing-top {  
      display: inline-block;  
      border-right: 2px solid #22b4fa;
      border-top: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: 0px;
      left: -5px;
  }
  #triangle-facing-bottom {  
      display: inline-block;  
      border-left: 2px solid #22b4fa;
      border-bottom: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: 3px;
      left: -5px;
  }
  #triangle-facing-right {  
      display: inline-block;  
      border-right: 2px solid #22b4fa;
      border-bottom: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: -5px;
      left: 37px;
  }
  .borderTop{
    width: 300px;
    height: 0;
    position: absolute;
    top: -17px;
    left: 183px;
    border-top: 2px solid #22b4fa;
  }
  .borderLeft{
    width: 0;
    height: 15px;
    position: absolute;
    top: -30px;
    left: 483px;
    border-left: 2px solid #22b4fa;
  }

  /*时间轴*/
  .timeLine{
    margin-top: 10px;
  }
  .timeLine li{
    /*border:solid 1px red;*/
    position: relative;
  }
  .timeLine .line{
    width: 100%;
    height: 62px;
    border-left: solid 4px rgb(136,146,156);
  }
  .timeLine .logoBox{
    width:28px;
    height:28px;
    border-radius: 50%;
    border: solid 2px rgb(136,146,156);
    position: absolute;
    left: -12px;
    top: -12px;
    z-index: 9;
  }
  .timeLine .logoBox i{
    position: absolute;
    top: 4px;
    left: 7px;
    font-size: 16px;
  }
  .timeLine .lineInfo{
      position: absolute;
      top: 10px;
      left: 35px;
  }
  .timeLine .lineInfo i{
    color:rgb(17,96,130);
    position: absolute;
    left: -6px;
    top: -18px;
    font-size: 16px
  }
   .timeLine .lineInfo span{
    color: #fff;
    background: rgb(17,96,130);
    padding: 5px;
    text-align: center;
    width: 110px;
    display: block;
    position: relative;
    top: -25px;
  }


  
</style>
<script>
  import api from '../../api/apinew'
  import leftBar from '../../components/leftBar'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        isLeftHiden: false,
        
      }
    },
    methods: {
      toggleClick () {
        this.isLeftHiden = !this.isLeftHiden;
      },
      togglemobileauto(ismobile){
        this.isLeftHiden = ismobile
      },
      doTry:function(){
        alert(22);
      }

    },
    components: {
      leftBar,
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?fc15702c